import { createAsyncThunk } from "@reduxjs/toolkit";
import festivalsService from "../../../api/services/festivals";

export const getFestivals = createAsyncThunk(
  "festivals/get-festivals",
  async ({ page, search, limit }) => {
    return await festivalsService.getFestivals({ page, search, limit });
  },
);

export const getAdminFestivals = createAsyncThunk(
  "festivals/get-admin-festivals",
  async ({ page, search, limit, includeInactive }) => {
    return await festivalsService.getFestivals({
      page,
      search,
      limit,
      includeInactive,
    });
  },
);

export const getFestivalById = createAsyncThunk(
  "festivals/get-festival-by-id",
  async (id) => {
    return await festivalsService.getFestivalById(id);
  },
);

export const getFestivalsForDropdown = createAsyncThunk(
  "festivals/get-festivals-for-dropdown",
  async () => {
    return await festivalsService.getFestivalsForDropdown();
  },
);

export const getFeaturedFestivals = createAsyncThunk(
  "festivals/get-featured-festivals",
  async () => {
    return await festivalsService.getFeaturedFestivals();
  },
);

export const createFestival = createAsyncThunk(
  "festivals/create-festival",
  async (requestData) => {
    return await festivalsService.createFestival(requestData);
  },
);

export const editFestival = createAsyncThunk(
  "festivals/edit-festival",
  async ({ id, requestData }) => {
    return await festivalsService.editFestival({ id, requestData });
  },
);

export const deleteFestival = createAsyncThunk(
  "festivals/delete-festival",
  async (id) => {
    return await festivalsService.deleteFestival(id);
  },
);

export const toggleFestivalStatus = createAsyncThunk(
  "festivals/toggle-festival-status",
  async (id) => {
    return await festivalsService.toggleFestivalStatus(id);
  },
);

// DASHBOARD PRISTUP

export const createFestivalDashboardAccess = createAsyncThunk(
  "festivals/create-dashboard-access",
  async ({ festivalId, username, password }) => {
    return await festivalsService.createDashboardAccess({
      festivalId,
      username,
      password,
    });
  },
);

export const fetchFestivalAdminCredentials = createAsyncThunk(
  "festivals/fetchAdminCredentials",
  async (festivalId, thunkAPI) => {
    try {
      const data = await festivalsService.getAdminCredentials(festivalId);
      return { festivalId, adminCredentials: data.adminCredentials };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message,
      );
    }
  },
);

export const resetFestivalDashboardPassword = createAsyncThunk(
  "festivals/reset-dashboard-password",
  async ({ festivalId, newPassword }) => {
    return await festivalsService.resetDashboardPassword({
      festivalId,
      newPassword,
    });
  },
);

export const removeFestivalDashboardAccess = createAsyncThunk(
  "festivals/remove-dashboard-access",
  async (festivalId) => {
    return await festivalsService.removeDashboardAccess(festivalId);
  },
);

export const getProductsByFestival = createAsyncThunk(
  "festivals/get-products-by-festival",
  async ({ id, page, limit, search }) => {
    return await festivalsService.getProductsByFestival({
      id,
      page,
      limit,
      search,
    });
  },
);

// FESTIVAL DETAILS

export const getFestivalDetails = createAsyncThunk(
  "festivals/get-festival-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await festivalsService.getFestivalDetails(id);
      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in getFestivalDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getFestivalPublicDetails = createAsyncThunk(
  "festivals/get-festival-public-details",
  async (id) => {
    return await festivalsService.getFestivalPublicDetails(id);
  },
);

export const getFestivalByName = createAsyncThunk(
  "festivals/get-festival-by-name",
  async (name) => {
    return await festivalsService.getFestivalByName(name);
  },
);

export const updateFestivalDetails = createAsyncThunk(
  "festivals/update-festival-details",
  async ({ id, data, isFormData }, { rejectWithValue }) => {
    try {
      const response = await festivalsService.updateFestivalDetails({
        id,
        data,
        isFormData,
      });
      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in updateFestivalDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
